import {handleFileSend, handleSend} from '../handleSend'

export const DeviceApi = {
  // 查询厂商信息列表
  queryFactoryInfoList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '33', '0002', '0', 'message')
  },
  // 新增/修改厂商信息
  handleFactoryInfo (data, type) {
    return handleSend(data, '33', '0001', String(type))
  },
  // 删除厂商信息
  deleteFactoryInfo (data) {
    return handleSend(data, '33', '0003')
  },
  // 查询产品信息列表
  queryProductInfoList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '33', '1002', '0', 'message')
  },
  // 新增/修改产品信息
  handleProductInfo (data, type) {
    return handleSend(data, '33', '1001', String(type))
  },
  // 删除产品信息
  deleteProductInfo (data) {
    return handleSend(data, '33', '1003')
  },
  // 查询型号信息列表
  queryTypeInfoList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '33', '2002', '0', 'message')
  },
  // 新增/修改型号信息
  handleTypeInfo (data, type) {
    return handleSend(data, '33', '2001', String(type))
  },
  // 删除型号信息
  deleteTypeInfo (data) {
    return handleSend(data, '33', '2003')
  },
  // 查询设备资料列表
  queryDeviceInfoList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '33', '3002', '0', 'message')
  },
  // 新增/修改设备资料
  handleDeviceInfo (data, type) {
    return handleSend(data, '33', '3001', String(type))
  },
  // 更改设备状态(0-报修、1-报废、2-恢复)
  updateDeviceStatus (data, type) {
    return handleSend(data, '33', '3003', String(type))
  },
  // 分配license
  assignLicense (data) {
    return handleSend(data, '33', '3004')
  },
  // 查询应用软件版本信息列表
  queryAppVersionList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '33', '4002', '0', 'message')
  },
  // 新增/修改应用软件版本信息
  handleAppVersion (data, type) {
    return handleSend(data, '33', '4001', String(type))
  },
  // 上传应用软件
  uploadAppVersionFile (data, versionno) {
    let fd = new FormData() // FormData 对象
    fd.append('file', data) // 文件对象
    fd.append('fileType', '0')
    fd.append('content', versionno)
    fd.append('AppCode', '33')
    fd.append('BizCode', '4003')
    return handleFileSend('/uploadFiles', '33', '4003', fd, 'Alert')
  },
  // 查询设备运维流水
  queryMaintenanceRecord (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '33', '4005', '0', 'message')
  },
  // 查询license
  queryLicenseList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '33', '5002', '0', 'message')
  },
  // 新增/修改license
  handleLicenseInfo (data, type) {
    data.quantity = String(data.quantity)
    return handleSend(data, '33', '5001', String(type))
  },
  // 删除license
  deleteLicenseInfo (data) {
    return handleSend(data, '33', '5003')
  },
  // 查询license分配
  queryLicenseAssign (data) {
    return handleSend(data, '33', '5004')
  }
}



// WEBPACK FOOTER //
// ./src/request/ApplyBasic/device_api.js